"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPlaceButton = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const AddPlaceButton = ({ title, onClick }) => (react_1.default.createElement("div", { className: 'add-place-button', style: onClick ? { cursor: 'pointer' } : undefined, onClick: onClick },
    react_1.default.createElement("div", { className: 'background' },
        react_1.default.createElement("div", { className: 'icon' },
            react_1.default.createElement("img", { src: common_1.ICONS.add, alt: "add" })),
        title && react_1.default.createElement("span", null, title))));
exports.AddPlaceButton = AddPlaceButton;
